import {EndPoints} from '../api-config';
let SERVER_ADDR_V1 = EndPoints.backendHost;

export const userByIdUrl = (id) => `${SERVER_ADDR_V1}/User/${id}`;
export const userAddressByUserIdUrl = (id) => `${SERVER_ADDR_V1}/User/${id}/address`;
export const userAddressByUserIdAndAddressIdUrl = (userId, addressId) => `${SERVER_ADDR_V1}/User/${userId}/address/${addressId}`;
export const userRepresentingByIdUrl = (id) => `${SERVER_ADDR_V1}/User/${id}/representing`;
export const userConnectionsUrl = (id) =>  `${SERVER_ADDR_V1}/user/${id}/connection`;
export const userServiceByIdUrl = (id, serviceId) =>  `${SERVER_ADDR_V1}/user/${id}/connection/${serviceId}`;
export const userServicesBatchUrl = (id) => `${SERVER_ADDR_V1}/user/${id}/connection/batch`;
export const generateUserLetterUrlByUserId = (userId) => `${SERVER_ADDR_V1}/userletter/user/${userId}`;
export const generateUserletterUrlByletterIdAndUserServiceId = (userId, userServiceId) => `${SERVER_ADDR_V1}/userletter/user/${userId}/userservice/${userServiceId}`;
export const userLetterUrlByUserId = (userId) => `${SERVER_ADDR_V1}/user/${userId}/userletter`;
export const letterUrlByletterId = (letterId) => `${SERVER_ADDR_V1}/letter/${letterId}`;
export const letterContentUrlByletterId = (letterId) => `${SERVER_ADDR_V1}/userletter/${letterId}/content`;
export const userletterUrlByletterId = (letterId) => `${SERVER_ADDR_V1}/userletter/${letterId}`;
export const userRepresentativeByUserIdUrl = (id) => `${SERVER_ADDR_V1}/user/${id}/userrepresentatives`;
export const userRepresentativesUrl = () => `${SERVER_ADDR_V1}/userRepresentative`;
export const userRepresentativesByIdUrl = (id) => `${SERVER_ADDR_V1}/userRepresentative/${id}`;
export const userRepresentativesInvitationByIdUrl = (id) => `${SERVER_ADDR_V1}/userRepresentative/${id}/invitation/send`;
export const sendOTPUrl = () => `${SERVER_ADDR_V1}/sendPhoneNumberOTP`;
export const verifyOTPUrl = () => `${SERVER_ADDR_V1}/verifyPhoneNumberOTP`;
export const addUserRoleUrl = (userId) => `${SERVER_ADDR_V1}/user/${userId}/adduserrole`;

